module.exports = __webpack_public_path__ + "img/csr-8.b6b99fb4.jpg";